import styled from 'styled-components';
import { Link } from 'gatsby';

const StyledLink = styled(Link)`
  text-decoration: none;
  color: var(--color-link-default);
`;

export default StyledLink;
